import './App.css';
import { useMemo } from 'react';
import * as anchor from '@project-serum/anchor';
import Home from './Home';
import { DEFAULT_TIMEOUT } from './connection';
import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from '@solana/wallet-adapter-wallets';

import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';
import { WalletDialogProvider } from '@solana/wallet-adapter-material-ui';

import { ThemeProvider, createTheme } from '@material-ui/core';

const theme = createTheme({
  palette: {
    type: 'dark',
  },
});

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    const candyMachineId = new anchor.web3.PublicKey(
      process.env.REACT_APP_CANDY_MACHINE_ID!,
    );

    return candyMachineId;
  } catch (e) {
    console.log('Failed to construct CandyMachineId', e);
    return undefined;
  }
};

const candyMachineId = getCandyMachineId();
const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(
  rpcHost ? rpcHost : anchor.web3.clusterApiUrl('devnet'),
);

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSlopeWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [],
  );

  return (
    <div className='main'>
      <div className="left">
        <div className="fleximg">
          <img src="mrb/0.png" alt="" />
          <img src="mrb/1.png" alt="" />
        </div>
        <div className="fleximg">
          <img src="mrb/2.png" alt="" />
          <img src="mrb/3.png" alt="" />
        </div>
        <div className="fleximg">
          <img src="mrb/5.png" alt="" />
          <img src="mrb/4.png" alt="" />
        </div>
        <div className="fleximg">
          <img src="mrb/6.png" alt="" />
          <img src="mrb/7.png" alt="" />
        </div>
      </div>
      <div>
        <h1><b>SoapRumble</b></h1>
        <br /><br />
        <p>
          Events of the day, free discussion, get proud, get loud! <br /><br />
          And not just that, we have NFT’s of leading characters, you can own, and display,
          trade, and collect, and they help promote your views on this site, at least.
        </p>
        <ThemeProvider theme={theme}>
          <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
              <WalletDialogProvider>
                <Home
                  candyMachineId={candyMachineId}
                  connection={connection}
                  txTimeout={DEFAULT_TIMEOUT}
                  rpcHost={rpcHost}
                  network={network}
                />
              </WalletDialogProvider>
            </WalletProvider>
          </ConnectionProvider>
        </ThemeProvider>
      </div>
      <div className="right">
        <div className="fleximg">
          <img src="mrp/0.png" alt="" />
          <img src="mrp/1.png" alt="" />
        </div>
        <div className="fleximg">
          <img src="mrp/2.png" alt="" />
          <img src="mrp/3.png" alt="" />
        </div>
        <div className="fleximg">
          <img src="mrp/4.png" alt="" />
          <img src="mrp/5.png" alt="" />
        </div>
        <div className="fleximg">
          <img src="mrp/6.png" alt="" />
          <img src="mrp/7.png" alt="" />
        </div>
      </div>
    </div>

  );
};

export default App;
